import React, { useEffect, useState } from 'react';
import messages from '../../statics/messages.json';
import orderContext from '../../context/OrderContext';
import OrderDetails from './OrderDetails';
import countriesData from '../../statics/countries.json';
import shipmentData from '../../statics/shipmentsData.json';
import statuses from '../../statics/status.json'
const OrderComplted = () => {
    const { orderFetch } = orderContext();
    const [orderData, setOrderData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [expandedRows, setExpandedRows] = useState([]);
    const [orderStatus, setorderStatus] = useState({});
    const [commentsMap, setCommentsMap] = useState(() => {
        // Comments NOT persisted to localStorage to avoid stale cached data
        return {};
    });
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    // const orderStatusOptions = ["Can Ship Early", "Do Not Ship Early", "CC Hold", "Wire Hold", "Credit Hold"];


    useEffect(() => {
        // Save commentsMap to local storage whenever it updates
        // Comments NOT persisted to localStorage to avoid stale cached data
    }, [commentsMap]);

    const fetchOrders = async (index, maxRecords, search) => {
        setLoading(true);
        const orders = await orderFetch(index, maxRecords, search,sortConfig.key,sortConfig.direction,"0");
        setOrderData(orders.order);
        setTotalRecords(orders.totalRecords);
        setLoading(false);
    };

    useEffect(() => {
        fetchOrders((currentPage - 1) * itemsPerPage, itemsPerPage, searchTerm);
    }, [currentPage, itemsPerPage,sortConfig]);

   const handleOrderStatusChange = (lineId, newStatus) => {
        setorderStatus((prevStatus) => ({
            ...prevStatus,
            [lineId]: newStatus,
        }));
    };;

    const totalPages = Math.ceil(totalRecords / itemsPerPage);

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const searchOrder = (value) => {
        setSearchTerm(value);
        setCurrentPage(1); // Reset to first page on new search
    };

    const toggleRowExpansion = (orderId) => {
        setExpandedRows(prev => 
            prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]
        );
    };

    const getCountryNameById = (id) => {
        const country = countriesData.find(country => country.Id == id);
        return country ? country.Country_Name : 'N/A';
    };

    const getShipmentMethodById = (id) => {
        const shipment = shipmentData.find(ship => ship.Id == id);
        return shipment ? shipment.MethodOfShipment : 'N/A';
    };
    const getStatusById = (id) => {
        const status = statuses.find(ship => ship.Id == id);
        return status ? status.status : 'N/A';
    };

    const handleKeyPress = (event) => {
        // if (event.key === 'Enter') {
            fetchOrders(0,10,searchTerm)
        // }else if (event.key === 'Backspace') {
        //     fetchOrders(0,10,'')
        // }

      };

      const handleCommentChange = (lineId, newComment) => {
        setCommentsMap(prev => ({
            ...prev,
            [lineId]: newComment
        }));
    };


    const handleSort = (key) => {
        
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
       
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return null;
        return sortConfig.direction === 'ascending' ? '▲' : '▼';
    };

      const getRowStyle = (date) => {
        
        const today = new Date();
        const targetDate = new Date(date);
        const timeDiff = targetDate - today;
        const diffDays =  Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        
        // if (diffDays >= 0 ) {
        //     return {Style:"display:none"};
        // }
        //   } else if (diffDays === 0) {
        //     return {Style:"background-color:#f9e25b"};
        //   } else if (diffDays === 1) {
        //     return {Style:"background-color:#aa83f3"};
        //   }else if (diffDays === 2) {
        //     return {Style:"background-color:#ff7d00cc"};
        //   } else if (diffDays <= 3) {
        //     return {};
        //   }
        return {}; // Default style
      };

    return (
        <div className="box-body border b-white rounded-2">
            <h4 className="p-2 m-0 border-bottom">Orders</h4>
            <div className="row px-2 pt-2">
                <div className="col-1 d-flex justify-content-start align-items-bottom">
                    <select
                        className="px-3 py-1 border rounded-1 d-inline"
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                    </select>
                </div>
                <div className='col-8'></div>
                <div className="col-3">
                    <input
                        type="text"
                        className="form-control"
                        id='search'
                        placeholder={messages.search_label}
                        value={searchTerm}
                        onChange={(e) => searchOrder(e.target.value)}
                        onKeyDown={handleKeyPress}
                    />
                </div>
                </div>
                <div className="row px-2 mt-2 over-flow-table">
                <div className="col-12 py-0">
                    {/* {loading ? (
                        <div className="text-center vh-50 d-flex justify-content-center align-items-center">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    ) : ( */}
                        <table className="table border rounded">
                            <thead class="table-sticky-head" style={{top:"-1px"}}>
                                <tr>
                                    <th className="text-center" onClick={() => handleSort('lineitem')}>{messages.line_item} {getSortIcon('lineitem')}</th>
                                    <th className="text-center" onClick={() => handleSort('ordernum')}>{messages.order_no_label} {getSortIcon('ordernum')}</th>
                                    <th className="text-center" onClick={() => handleSort('name')}>{messages.customer_name_label} {getSortIcon('name')}</th>
                                    <th className="text-center" onClick={() => handleSort('custponum')}>{messages.po_no_label} {getSortIcon('custponum')}</th>
                                    <th className="text-center" onClick={() => handleSort('prcpart')}>{messages.part_no} {getSortIcon('prcpart')}</th>
                                    <th className="text-center" >{messages.qty_label}</th>
                                    <th className="text-center" onClick={() => handleSort('status')}>{messages.status_label} {getSortIcon('status')}</th>
                                    <th className="text-center" onClick={() => handleSort('orig_shipdate')}>{messages.shipping_date_label} {getSortIcon('orig_shipdate')}</th>
                                    <th className="text-center" onClick={() => handleSort('method_of_shipment')}>{messages.shipping_method_label} {getSortIcon('method_of_shipment')}</th>
                                    <th className="text-center" onClick={() => handleSort('country_name')}>{messages.country_label} {getSortIcon('country_name')}</th>
                                    <th className="text-center">{messages.comments_label}</th>
                                    <th className="text-center">{messages.order_status_label}</th>
                                    {/* <th className="text-center">{messages.action_label}</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                    {orderData != undefined && orderData.length > 0 ? (
                                        orderData.map((line, lineIndex) => {
                                        return (
                                            <tr key={`${line.order.id}-${lineIndex}`} {...getRowStyle(line.shipdate?line.shipdate:line.orig_shipdate)} > 
                                            {/* This displays order-specific information once per line */}
                                            <td className='text-center'>
                                            {/* Calculate the serial number (slno) for each row */}
                                            {line.lineitem}
                                            </td>
                                            <td className='text-center'>
                                            <a href={`https://gigaflightinc.cetecerp.com/order/MN${line.order.ordernum}/view`} target='_blank' rel='noopener noreferrer'>
                                                {line.order.ordernum}
                                            </a>
                                            </td>
                                            <td>{line.order.customer === undefined ? '' : line.order.customer.name}</td>
                                            <td>{line.order.custponum}</td>
                                            <td>{line.prcpart.substring(3) || 'N/A'}</td>
                                            <td>{line.oorderqty || 'N/A'}</td>
                                            <td>
                                            <a className="p-1 px-2 text-decoration-none text-light bg-success rounded">
                                                {/* {getStatusById(line.status) || 'N/A'} */} {line.statusObj.status}
                                            </a>
                                            </td>
                                            <td>{line.shipdate?line.shipdate:line.orig_shipdate}</td>
                                            <td>{line.order.shipmentMethod.methodOfShipment}</td>
                                            {/* getShipmentMethodById(line.order.shipvia) */}
                                            <td className={line.order.country.country_Name !== 'United States'?'bg-dark text-light text-center country-cell-intl':(line.order.country.country_Name === 'United States' ? 'text-center country-cell-us' : 'text-center')}>{line.order.country.country_Name}</td>
                                            {/* getCountryNameById(line.order.shipto_country_id) */}
                                            <td>
                                            <textarea
                                                              value={commentsMap[line.id] || ''}
                                                              onChange={(e) => handleCommentChange(line.id, e.target.value)}
                                                              rows={2}
                                                              style={{ width: '100%', resize: 'none' }}
                                            />
                                            </td>
                                            <td className="text-center">
                                            <select
                                                                    value={orderStatus[line.id] || 'Can ship early'}
                                                                    onChange={(e) => handleOrderStatusChange(line.id, e.target.value)}
                                                                    className="form-select"
                                                                    style={{
                                                                        color: orderStatus[line.id] === 'Credit hold' ? 'red' :
                                                                        orderStatus[line.id] === 'CC hold' ? 'orange' :
                                                                        orderStatus[line.id] === 'Wire hold' ? '#8B47FF' : // Purple
                                                                        orderStatus[line.id] === 'Do not ship early' ? '#F8D700' : // Yellow
                                                                        'green',
                                                                 backgroundColor: 'white',
                                                                 borderColor: orderStatus[line.id] === 'Credit hold' ? 'red' :
                                                                              orderStatus[line.id] === 'Do not ship early' ? '#F8D700' : // Yellow
                                                                              orderStatus[line.id] === 'Wire hold' ? '#8B47FF' : // Purple
                                                                              'green',
                                                                 fontWeight: 'bold',                                                                              
                                                                        
                                                                   }}
                                            >
                                                                    <option value="Can ship early" style={{ color: 'green' }}>Can ship early</option>
                                                                    <option value="Do not ship early" style={{ color: '#F8D700' }}>Do not ship early</option>
                                                                    <option value="CC hold" style={{ color: 'orange' }}>CC hold</option>
                                                                    <option value="Wire hold" style={{ color: '#8B47FF' }}>Wire hold</option>
                                                                    <option value="Credit hold" style={{ color: 'red' }}>Credit hold</option>
                                                </select>
                                            
                                            {/* <a className="p-1 px-2 text-decoration-none text-light bg-success rounded">
                                                {getStatusById(order.orderstatus) || 'N/A'}
                                            </a> */}
                                            </td>
                                        </tr>
                                        );
                                        })
                                    ) : (
                                        <tr>
                                        <td colSpan="14">No data available</td>
                                        </tr>
                                    )}
                                    </tbody>

                        </table>
                    {/* )} */}
                </div>
                <div className="col-12 py-2">
                    <nav aria-label="Page navigation example">
                        <span>
                            Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalRecords)} of {totalRecords}
                        </span>
                        <ul className="pagination float-end">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, index) => (
                                <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                </div>
                </div>
           
        </div>
    );
};

export default OrderComplted;

